import HoldingFleetInvoicesInternal from "features/holding-fleets/invoices";

export const HoldingFleetInvoices = () => <HoldingFleetInvoicesInternal />;
